const Footer = () => {
  return (
    <footer className="text-center py-4 text-sm text-muted-foreground">
      <p>&copy; 2025 AptFleet. All rights reserved.</p>
      <nav className="px-6 sm:ml-auto flex gap-4 sm:gap-6">
        <a className="text-xs hover:underline underline-offset-4" href="/terms">
          Terms of Service
        </a>
        <a
          className="text-xs hover:underline underline-offset-4"
          href="/privacy"
        >
          Privacy
        </a>
      </nav>
    </footer>
  );
};

export default Footer;

// <footer className="flex flex-col gap-2 sm:flex-row py-6 w-full shrink-0 items-center px-4 md:px-6 border-t">
// <p className="text-xs text-gray-500 dark:text-gray-400">
//   © 2024 AptFleet. All rights reserved.
// </p>

// </footer>
